<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper dashboard-wrapper">
      <!-- Main content -->
      <section class="content">
      
        <div class="row">
          <div class="col-md-12">
              <a href="#/accidentInformationPage">
            <div class="box  palette-Dark bg">
              <div class="box-header  palette-Dark bg">
                <div class="pull-right text-white box-tools">
                  <span class="text-white box-btn"
                    ><i class="material-icons">directions_car</i></span
                  >&nbsp;&nbsp;&nbsp;
                </div>
                <h3 class="box-title">
                  <span class="text-white">&nbsp;&nbsp;&nbsp;REPORT AN ACCIDENT</span>
                </h3>
              </div>
              <div class="box-body no-pad" style="display: block">
                <div class="events-nest">
                    <h2 class="text-white">
                      <strong><span style="color: white;">File your Auto-Accident Claim Here</span></strong>
                    </h2>
                                        <h4  style="color: white;">Report your auto-accident to get started with getting your claim.</h4>

                  <div class="wrap-no-pad text-white accident-post-nest">
                   

                  </div>
                  <div >
                    <br>
                    <h6 style="color:white;"><strong><b>Click/Tap Here to Get started.</b></strong></h6>
</div>
                </div>
              </div>
            </div>
              </a>
          </div>
          <div class="col-md-12">
                            <a href="#/updatePlaceholder">

            <div class="box  palette-Dark bg">
              <div class="box-header  palette-Dark bg">
                <div class="pull-right text-white box-tools">
                  <span class="text-white box-btn"
                    ><i class="material-icons">assignment_turned_in</i></span
                  >&nbsp;&nbsp;&nbsp;
                </div>
                <h3 class="box-title">
                  <span class="text-white">&nbsp;&nbsp;&nbsp;CLAIM STATUS</span>
                </h3>
              </div>
              <div class="box-body no-pad" style="display: block">
                <div class="events-nest">
                    <h2 class="text-white" style="color: white">
                      <strong><span>Auto-Accident Claim Status</span></strong>
                    </h2>
                                        <h4 style="color: white;">Check the progress of your Auto-Accident here.</h4>

                  <div class="wrap-no-pad text-white status-post-nest">
                  </div>
                  <br>
                <div>                    <h6 style="color:white;"><strong><b>Click/Tap Here to Get started.</b></strong></h6>
              </div>
                </div>
              </div>
            </div>
                            </a>
          </div>
          
          <div class="col-md-12">
                                          <a href="#/updatePlaceholder">

            <div class="box  palette-Dark bg">
              <div class="box-header palette-Indigo-900 palette-Dark bg">
                <div class="pull-right text-white box-tools">
                  <span class="text-white box-btn"
                    ><i class="material-icons">card_giftcard</i></span
                  >&nbsp;&nbsp;&nbsp;
                </div>
                <h3 class="box-title">
                  <span class="text-white"
                    >&nbsp;&nbsp;&nbsp;OFFERS/REWARDS</span
                  >
                </h3>
              </div>
              <div class="box-body no-pad" style="display: block">
                <div class="events-nest">
                    <div style = "color: white;">
                    <h2 class="text-white">
                      <strong><span>Check Your Rewards</span></strong>
                    </h2>
                    <h4 style="color: white;">Check here for new offers and rewards!</h4>
                    </div>
                  <div class="wrap-no-pad text-white offers-post-nest">
                   
                  </div>
                  <br>
                   <div>                    <h6 style="color:white;"><strong><b>Click/Tap Here to Get started.</b></strong></h6>
              </div>
                </div>
              </div>
            </div>
                                          </a>
          </div>
        </div>
    
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
 
const Auth = require('../../../services/Authentication/auth')
const to = require('await-to-js').default
const cliStoreOps = require('../../../common/clientStorageOperations')

  export default {
  name: "dashboard-first",
    data: function () {
      return {
        userDocument: {}
      }
    },
    beforeCreate() {
              //needs to be moved to more centralized location
   
      
    
    
    },
   async beforeMount(){
      this.userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
  let userErr, userRes
          [userErr, userRes] = await to(Auth.getUser({ UID: this.userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
                  cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()
                  this.$router.push('/login')

          } 
     console.log("userDoc", this.$route.params)
      if (this.$route.params && this.$route.params.userDocument){
        this.userDocument =  this.$route.params.userDocument
      }
    }
  }
</script>


<style scoped>
body {
  background: orange;
  overflow: hidden;
  color: white;
}
.GeeksForGeeks {
  text-align: center;
  background: dodgerblue;
  position: absolute;
  top: 50%;
  left: 1%;
  right: 1%;
}
</style>


// WEBPACK FOOTER //
// Index.vue?23e012d2